/**
 * 過去画像登録画面の値を管理するクラス
 *
 * @export KYMW1705Model
 * @class KYMW1705Model
 */
export class KYMW1705Model {
  // 画像ファイル名
  public imageFileName:string = <string>'';
  // 画像プレビューURLURL
  public imagePreviewUrl:string = <string>'';
  // 画像ID
  public imageId: string = <string>'';
  // 呼出元画像ID
  public callerImageId: string = <string>'';
}
